<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
       <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.visit list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Visit"
          style="cursor: pointer;" @click="addNewRow" />
        <div class="tool-tip mt-2">Add Visit</div>
      </div>
      </div>
      <div class="ibox-content">
        <div>
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Visit No <sup><i class="fa fa-asterisk required"></i></sup></th>
                  <th>Visit Name <sup><i class="fa fa-asterisk required"></i></sup></th>
                  <th>Visit Short Label</th>
                  <th>Study Phase</th>
                  <th>Visit Type <sup><i class="fa fa-asterisk required"></i></sup></th>
                  <th>Is Cycle Visit?</th>
                  <th>Cycle ID</th>
                  <th>Cycle Name</th>
                  <th>Visit Notes</th>
                  <th>Visit Required?</th>
                  <th>Pre-Visit (Days)</th>
                  <th>Post-Visit (Days)</th>
                  <th>Visit Period (Days)</th>
                  <th>Visit Period (Weeks)</th>
                  <th>Visit Period (Months)</th>
                  <th>Visit Period (Years)</th>
                  <th>Planned Days</th>
                  <th>SoA ID</th>
                  <th class="text-center sticky-column">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>

                <!-- New Row for creation -->
                <tr v-if="isAddingNew">
                  <td>
                    <input v-model="newRow.visitNumber" class="form-control" type="text"
                      @input="clearNewFieldError('visitNumber')" />
                    <div v-if="newRowErrors.visitNumber" class="text-danger">{{ newRowErrors.visitNumber }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.visitName" class="form-control" type="text"
                      @input="clearNewFieldError('visitName')" />
                    <div v-if="newRowErrors.visitName" class="text-danger">{{ newRowErrors.visitName }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.visitShortLabel" class="form-control" type="text" />
                  </td>
                  <td>
                    <input v-model="newRow.studyPhase" class="form-control" type="text" />
                  </td>
                  <td>
                    <select class="form-select" v-model="newRow.visitType"
                      @change="clearNewFieldError('visitType')"
                      :class="{ 'is-invalid': newRowErrors.visitType }">
                      <option disabled value="">{{ $t("navigations.select") }}</option>
                      <option v-for="option in visitList" :key="option.typename" :value="option.typename">
                        {{ option.typename }}
                      </option>
                    </select>
                    <span v-if="newRowErrors.visitType" class="errormsg text-danger">
                      {{ newRowErrors.visitType }}
                    </span>
                  </td>
                  <td>
                    <select class="form-select" v-model="newRow.isCycleVisit">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </td>
                  <td>
                    <input v-model="newRow.cycleId" class="form-control" type="text" />
                  </td>
                  <td>
                    <input v-model="newRow.cycleName" class="form-control" type="text" />
                  </td>
                  <td>
                    <textarea v-model="newRow.visitNotes" class="form-control" rows="3"></textarea>
                  </td>
                  <td>
                    <select class="form-select" v-model="newRow.visitRequired">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </td>
                  <td>
                    <input v-model.number="newRow.preVisitDays" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model.number="newRow.postVisitDays" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model.number="newRow.visitPeriodDays" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model.number="newRow.visitPeriodWeeks" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model.number="newRow.visitPeriodMonths" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model.number="newRow.visitPeriodYears" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model.number="newRow.plannedDays" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model="newRow.soaId" class="form-control" type="text" />
                  </td>
                  <td class="text-center sticky-column">
                    <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                  </td>
                  <td></td>
                </tr>

                <!-- No data row -->
                <tr v-if="!isAddingNew && visits.length === 0">
                  <td colspan="19" class="text-center">No data available.</td>
                </tr>
                <tr v-for="(visit, index) in visits" :key="visit.id">
                  <!-- Visit No -->
                  <td v-if="editIndex !== index">{{ visit.visitNumber }}</td>
                  <td v-else>
                    <input v-model="editableRow.visitNumber" class="form-control" type="text"
                      @input="clearFieldError('visitNumber')" />
                    <div v-if="validationErrors.visitNumber" class="text-danger">{{ validationErrors.visitNumber }}</div>
                  </td>
                  <!-- Visit Name -->
                  <td v-if="editIndex !== index">{{ visit.visitName }}</td>
                  <td v-else>
                    <input v-model="editableRow.visitName" class="form-control" type="text"
                      @input="clearFieldError('visitName')" />
                    <div v-if="validationErrors.visitName" class="text-danger">{{ validationErrors.visitName }}</div>
                  </td>
                  <!-- Visit Short Label -->
                  <td v-if="editIndex !== index">{{ visit.visitShortLabel }}</td>
                  <td v-else>
                    <input v-model="editableRow.visitShortLabel" class="form-control" type="text" />
                  </td>
                  <!-- Study Phase -->
                  <td v-if="editIndex !== index">{{ visit.studyPhase }}</td>
                  <td v-else>
                    <input v-model="editableRow.studyPhase" class="form-control" type="text" />
                  </td>
                  <!-- Visit Type -->
                  <td v-if="editIndex !== index">{{ visit.visitType }}</td>
                  <td v-else>
                    <div>
                      <select class="form-select" v-model="editableRow.visitType"
                        @input="clearFieldError('visitType')"
                        :class="{ 'is-invalid': validationErrors.visitType }">
                        <option disabled value="">{{ $t("navigations.select") }}</option>
                        <option v-for="option in visitList" :key="option.typename" :value="option.typename">
                          {{ option.typename }}
                        </option>
                      </select>
                      <span v-if="validationErrors.visitType" class="errormsg text-danger">
                        {{ validationErrors.visitType }}
                      </span>
                    </div>
                  </td>
                  <!-- Is Cycle Visit? -->
                  <td v-if="editIndex !== index">{{ visit.isCycleVisit ? "Yes" : "No" }}</td>
                  <td v-else>
                    <select class="form-select" v-model="editableRow.isCycleVisit">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </td>
                  <!-- Cycle ID -->
                  <td v-if="editIndex !== index">{{ visit.cycleId }}</td>
                  <td v-else>
                    <input v-model="editableRow.cycleId" class="form-control" type="text" />
                  </td>
                  <!-- Cycle Name -->
                  <td v-if="editIndex !== index">{{ visit.cycleName }}</td>
                  <td v-else>
                    <input v-model="editableRow.cycleName" class="form-control" type="text" />
                  </td>
                  <!-- Visit Notes -->
                  <td v-if="editIndex !== index">
                    <div class="wrap-text">{{ visit.visitNotes }}</div>
                  </td>
                  <td v-else>
                    <textarea v-model="editableRow.visitNotes" class="form-control" rows="3"></textarea>
                  </td>
                  <!-- Visit Required? -->
                  <td v-if="editIndex !== index">{{ visit.visitRequired ? "Yes" : "No" }}</td>
                  <td v-else>
                    <select class="form-select" v-model="editableRow.visitRequired">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </td>
                  <!-- Pre-Visit (Days) -->
                  <td v-if="editIndex !== index">{{ visit.preVisitDays }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.preVisitDays" class="form-control" type="number" />
                  </td>
                  <!-- Post-Visit (Days) -->
                  <td v-if="editIndex !== index">{{ visit.postVisitDays }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.postVisitDays" class="form-control" type="number" />
                  </td>
                  <!-- Visit Period (Days) -->
                  <td v-if="editIndex !== index">{{ visit.visitPeriodDays }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.visitPeriodDays" class="form-control" type="number" />
                  </td>
                  <!-- Visit Period (Weeks) -->
                  <td v-if="editIndex !== index">{{ visit.visitPeriodWeeks }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.visitPeriodWeeks" class="form-control" type="number" />
                  </td>
                  <!-- Visit Period (Months) -->
                  <td v-if="editIndex !== index">{{ visit.visitPeriodMonths }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.visitPeriodMonths" class="form-control" type="number" />
                  </td>
                  <!-- Visit Period (Years) -->
                  <td v-if="editIndex !== index">{{ visit.visitPeriodYears }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.visitPeriodYears" class="form-control" type="number" />
                  </td>
                  <!-- Planned Days -->
                  <td v-if="editIndex !== index">{{ visit.plannedDays }}</td>
                  <td v-else>
                    <input v-model.number="editableRow.plannedDays" class="form-control" type="number" />
                  </td>
                  <!-- SoA ID -->
                  <td v-if="editIndex !== index">{{ visit.soaId }}</td>
                  <td v-else>
                    <input v-model="editableRow.soaId" class="form-control" type="text" />
                  </td>
                  <!-- Edit Actions -->
                  <td class="text-center sticky-column">
                    <template v-if="editIndex !== index">
                      <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                        @click.prevent="editRow(index, visit)"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-check action-icon text-success" @click="updateRow(visit.id, visit.studyId)"
                        title="Update"></i>
                      <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                    </template>
                  </td>
                  <!-- Delete -->
                  <td class="text-center">
                    <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                      @click="deleteRow(visit.id)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination  -->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}
.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 300px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}
.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>
<script src="./VisitManagement.js"></script>